export default __webpack_public_path__ + "static/media/Slack.ca9878d8.png";